import moment from 'moment';
import isNil from 'lodash/isNil';
import get from 'lodash/get';
import intersection from 'lodash/intersection';

import {
  CAMINO_EVENTS_HE,
  CAMINO_SUBSCRIPTION,
  REP_VISITS_SUBSCRIPTION,
} from '../containers/Authorization/constants';
import { getTimeLocal } from '../containers/CollegeEventsEditEvent/timezones';

export const isCaminoEventsEnabled = (enabledFeatures) =>
  enabledFeatures && enabledFeatures.includes(CAMINO_EVENTS_HE);

export const getAllowedSubscriptions = (caminoEventsEnabled) =>
  (caminoEventsEnabled ?
    [REP_VISITS_SUBSCRIPTION, CAMINO_SUBSCRIPTION] :
    [REP_VISITS_SUBSCRIPTION]);

function getEventCategory(status, wasPublished, expired) {
  if ((status === 'PUBLISHED' || wasPublished) && expired) return 'expired';
  if (status === 'PUBLISHED') return 'published';
  if (status === 'UNPUBLISHED') return 'unpublished';
  return 'unknown';
}

export const isEventExpired = (event) => {
  const date = event.registrationDeadline || event.eventDateTime || 0;
  const time = event.registrationDeadlineTime || event.startTime;
  let hours = time ? parseInt(time.split(':')[0], 10) : 0;
  const plus12 = time && time.includes('p');
  hours = hours !== 12 && plus12 ? hours + 12 : hours;
  const minutes = time ? parseInt(time.split(/[:ap]/)[1], 10) : 0;
  return parseInt(date + (hours * 3600000) + (minutes * 60000), 10) < Date.now();
};

export const createEventObjectArray = ({ rawEvents, showCamino, showNaviance }) => {
  let events = rawEvents
    .map((eventNode) => {
      const event = eventNode.node;
      const wasUpdated = event.lastModifiedDate > event.created;
      const createdString = `Created ${moment(event.created).format('ddd, MMM D, YYYY')}`;
      const updatedString = `Updated ${moment(event.lastModifiedDate).format('ddd, MMM D, YYYY')}`;
      const expired = isEventExpired(event);
      const isOvernight = event.eventEndDateTime > event.eventDateTime;
      return {
        ...event,
        category: getEventCategory(event.status, event.wasPublished, expired),
        past: expired,
        displayDate: moment(getTimeLocal(event.eventDateTime)).format('ddd, MMMM D'),
        endDate: isOvernight ? ` - ${moment(getTimeLocal(event.eventEndDateTime)).format('ddd, MMMM D')}` : '',
        location: (event.collegeEventLocation || {}).name || '',
        state: (event.collegeEventLocation || {}).state || '',
        authored: wasUpdated ? updatedString : createdString,
        authoredTime: wasUpdated ? event.lastModifiedDate : event.created,
      };
    })
    .sort((a, b) => b.authoredTime - a.authoredTime);

  if (!isNil(showCamino) || !isNil(showNaviance)) {
    events = events.filter((event) => {
      const camino = get(event, 'displayIn.camino', false);
      const naviancestudent = get(event, 'displayIn.naviancestudent', false);
      if (showCamino && camino) return true;
      if (showNaviance && naviancestudent) return true;
      return false;
    });
  }

  const published = events.filter((event) => event.category === 'published').length;
  const drafts = events.filter((event) => event.category === 'unpublished').length;
  const expired = events.filter((event) => event.category === 'expired').length;
  return { events, published, drafts, expired };
};

export const getDisplayInDefaults = ({ activeSubscriptions }) => {
  const allowedSubscriptions = getAllowedSubscriptions(true);
  const subscriptions = intersection(
    allowedSubscriptions,
    activeSubscriptions,
  );
  return {
    displayInCheckboxes: subscriptions.length === 2,
    isCaminoChecked: subscriptions.includes(CAMINO_SUBSCRIPTION),
    isNavianceChecked: subscriptions.includes(REP_VISITS_SUBSCRIPTION),
  };
};

export const getDisplayInMessage = ({
  event,
  enabledFeatures,
  activeSubscriptions,
  messages,
  intl,
}) => {
  const displayIn = get(event, 'displayIn');
  if (isCaminoEventsEnabled(enabledFeatures) && displayIn) {
    const allowedSubscriptions = getAllowedSubscriptions(true);
    const subscriptions = intersection(
      allowedSubscriptions,
      activeSubscriptions,
    );
    if (subscriptions.length === 2) {
      let message = '';
      const hasCamino = get(displayIn, 'camino', false);
      const hasNaviance = get(displayIn, 'naviancestudent', false);
      /* istanbul ignore else */
      if (hasCamino && hasNaviance) {
        message = intl.formatMessage(messages.viewEventsCaminoNaviance);
      } else if (hasCamino) {
        message = intl.formatMessage(messages.viewEventsCamino);
      } else if (hasNaviance) {
        message = intl.formatMessage(messages.viewEventsNaviance);
      }
      /* istanbul ignore else */
      if (message.length > 0) {
        return ` - ${message}`;
      }
    }
  }
  return '';
};
